export const mergeInflections = (inflections) =>
  inflections.reduce((res, el) => res.concat(el.inflexion), []).join(" / ");
